import { precompileTemplate } from "@ember/template-compilation";
export default precompileTemplate("<Loading/>\n",{ moduleName: "frontend/templates/loading.hbs" })